import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { SolicitacaoHonraService } from "src/app/features/honra/solicitacao-honra/solicitacao-honra.service";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { SolicitacaoHonra } from "src/app/model/solicitacao-honra.model";

@Component({
    selector: 'aba-solicitacoes-honra',
    templateUrl: 'aba-solicitacoes-honra.component.html',
    standalone: false
})
export class AbaSolicitacoesDeHonraComponent implements OnChanges {
    @Input()
    public model: OperacaoGarantida;
    solicitacoes: SolicitacaoHonra[];
    showMessage: Boolean;

    constructor(
        private solicitacaoDeHonraService: SolicitacaoHonraService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.solicitacaoDeHonraService.getSolicitacoesHonraOperacao(this.model.id).subscribe(resp => {
            this.solicitacoes = resp && resp.resultados ? resp.resultados : [];
            this.showMessage = !this.solicitacoes?.length;
        });
    }

}

